'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// styled


var _fetchEverywhere = require('fetch-everywhere');

var _fetchEverywhere2 = _interopRequireDefault(_fetchEverywhere);

var _getNested = require('get-nested');

var _getNested2 = _interopRequireDefault(_getNested);

var _google_tag = require('google_tag');

var _google_tag2 = _interopRequireDefault(_google_tag);

var _mobxReact = require('mobx-react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _reactGoogleRecaptcha = require('react-google-recaptcha');

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _Forms = require('../Observables/Forms');

var _Forms2 = _interopRequireDefault(_Forms);

var _Parser = require('../Parser');

var _Parser2 = _interopRequireDefault(_Parser);

var _ThankYouMessage = require('./ThankYouMessage');

var _ThankYouMessage2 = _interopRequireDefault(_ThankYouMessage);

var _WebformElement = require('../WebformElement');

var _WebformElement2 = _interopRequireDefault(_WebformElement);

var _theme = require('../styles/theme');

var _theme2 = _interopRequireDefault(_theme);

var _webform = require('./styled/webform');

var _webform2 = _interopRequireDefault(_webform);

var _formTitle = require('./styled/form-title');

var _formTitle2 = _interopRequireDefault(_formTitle);

var _list = require('./styled/list');

var _list2 = _interopRequireDefault(_list);

var _listItem = require('./styled/list-item');

var _listItem2 = _interopRequireDefault(_listItem);

var _element = require('./styled/element');

var _element2 = _interopRequireDefault(_element);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Webform = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Webform, _Component);

  function Webform(props) {
    (0, _classCallCheck3.default)(this, Webform);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Webform.__proto__ || (0, _getPrototypeOf2.default)(Webform)).call(this, props));

    _this.recaptchaRef = null;


    _this.state = {
      status: Webform.formStates.DEFAULT,
      errors: {},
      loadingTimeout: false
    };

    _this.key = props.form.form_id;

    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.submit = _this.submit.bind(_this);

    _this.formStore = _this.getFormstore(props);
    return _this;
  }

  (0, _createClass3.default)(Webform, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var GTM = (0, _getNested2.default)(function () {
        return _this2.props.settings.tracking.gtm_id;
      }) || this.props.form.settings.nm_gtm_id;

      if (GTM) {
        _google_tag2.default.addTag(GTM);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.formStore = this.getFormstore(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.loadingTimeout);
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(e) {
      e.preventDefault();

      // If the 'onSubmit' is being overwritten, use that function.
      // If it returns false, don't submit, otherwise continue.
      if (typeof this.onSubmitOverwrite === 'function') {
        var result = this.onSubmitOverwrite(e);
        if (!result) {
          return result;
        }
      }

      // Make sure that all errors are visible by marking all visible fields as blurred.
      this.formStore.visibleFields.forEach(function (field) {
        field.isBlurred = true;
      });

      var isValid = this.isValid();
      if (isValid) {
        if (this.getCaptchaField() && this.recaptchaRef) {
          return this.recaptchaRef.execute();
        }
        return this.updateSubmission();
      }
      console.warn('The user tried to submit a form, but not all fields are valid.');

      return true;
    }
  }, {
    key: 'getCaptchaField',
    value: function getCaptchaField() {
      return this.formStore.form.elements.find(function (field) {
        return field['#type'] === 'captcha';
      });
    }
  }, {
    key: 'getFormstore',
    value: function getFormstore(props) {
      return _Forms2.default.getForm(props.form.form_id, {
        form: props.form,
        settings: props.settings,
        defaultValues: this.props.defaultValues
      });
    }
  }, {
    key: 'getFormElements',
    value: function getFormElements() {
      var _this3 = this;

      var formElements = (0, _getNested2.default)(function () {
        return _this3.props.form.elements;
      }, []);
      return formElements.map(function (field) {
        return _react2.default.createElement(_WebformElement2.default, {
          key: field['#webform_key'],
          field: field,
          formStore: _this3.formStore,
          settings: _this3.props.form.settings,
          webformSettings: _this3.props.settings,
          status: _this3.state.status,
          form: _this3.props.form,
          loadingTimeout: _this3.state.loadingTimeout,
          loadingComponent: _this3.props.loadingComponent,
          url: _this3.props.url
        });
      });
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      return this.formStore.valid;
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      _Forms2.default.deleteForm(this.props.form.form_id);
      this.formStore = this.getFormstore(this.props);
    }
  }, {
    key: 'updateSubmission',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _this4 = this;

        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.props.loadingComponent) {
                  this.loadingTimeout = setTimeout(function () {
                    _this4.setState({ loadingTimeout: true });
                  }, this.props.loadingTimeout);
                }

                _context.next = 3;
                return this.props.onSubmit(this);

              case 3:
                response = _context.sent;

                if (!(!response || response.submit !== false)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return this.submit();

              case 7:
                response = _context.sent;

              case 8:

                clearTimeout(this.loadingTimeout);
                this.setState({ loadingTimeout: false });

                if (response.status === 200 || response.status === 201) {
                  this.response = response;
                  this.setState({ status: Webform.formStates.SENT });
                  this.props.onSubmitSuccess({
                    webform: this,
                    response: this.response,
                    values: this.formStore.values
                  }); // Trigger onSubmitSuccess hook.
                  this.resetForm();
                } else {
                  this.setState({
                    status: Webform.formStates.ERROR,
                    errors: response.message || []
                  });
                  this.props.onSubmitFail(this); // Trigger onSubmitFail hook.
                }

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateSubmission() {
        return _ref.apply(this, arguments);
      }

      return updateSubmission;
    }()
  }, {
    key: 'submit',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var extraFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var headers, values, response;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // eslint-disable-next-line no-undef
                headers = new Headers({
                  'Content-Type': 'application/json',
                  'X-CSRF-Token': this.props.form.token
                });
                values = (0, _assign2.default)({}, this.props.hiddenData, this.formStore.values);

                if (!extraFields.in_draft) {
                  this.setState({ status: Webform.formStates.PENDING });
                }

                _context2.prev = 3;
                _context2.next = 6;
                return (0, _fetchEverywhere2.default)(this.props.url + '/hn-webform-submission?_format=json', {
                  headers: headers,
                  method: 'POST',
                  body: (0, _stringify2.default)((0, _assign2.default)({
                    form_id: this.props.form.form_id
                  }, extraFields, values))
                });

              case 6:
                response = _context2.sent;
                return _context2.abrupt('return', response.json());

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](3);

                console.error(_context2.t0);
                return _context2.abrupt('return', null);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 10]]);
      }));

      function submit() {
        return _ref2.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      if (!this.formStore) return null;
      var formElements = this.getFormElements();

      var requiredHint = null;
      if (this.formStore.visibleFields.find(function (field) {
        return field.required;
      }) && this.props.form.settings.nm_required_hint) {
        requiredHint = _react2.default.createElement(
          'span',
          null,
          (0, _Parser2.default)(this.props.form.settings.nm_required_hint)
        );
      }
      var errors = (0, _entries2.default)(this.state.errors);
      var errorsEl = errors.length > 0 && _react2.default.createElement(
        _list2.default,
        null,
        errors.map(function (_ref3) {
          var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
              key = _ref4[0],
              error = _ref4[1];

          return _react2.default.createElement(
            _listItem2.default,
            { key: key },
            _react2.default.createElement(
              _element2.default,
              { error: true },
              key.replace(/]\[/g, '.'),
              ': ',
              _react2.default.createElement(
                'em',
                null,
                (0, _Parser2.default)(error)
              )
            )
          );
        })
      );

      var renderCaptcha = function renderCaptcha() {
        var field = _this5.getCaptchaField();

        if (!field) {
          return null;
        }

        if (!field['#captcha_sitekey']) {
          console.warn('No google reCaptcha sitekey found.');
          return null;
        }

        return _react2.default.createElement(
          'div',
          { className: 'hrw-captcha-wrap' },
          _react2.default.createElement(_reactGoogleRecaptcha2.default, {
            size: 'invisible',
            sitekey: field['#captcha_sitekey'],
            ref: function ref(_ref5) {
              _this5.recaptchaRef = _ref5;
            },
            onChange: function onChange() {
              return _this5.updateSubmission();
            },
            hl: _this5.props.settings.langcode || _this5.props.form.langcode || 'en'
          })
        );
      };

      return _react2.default.createElement(
        _mobxReact.Provider,
        { formStore: this.formStore, submit: this.submit, webform: this },
        _react2.default.createElement(
          _styledComponents.ThemeProvider,
          { theme: (0, _extends3.default)({}, _theme2.default, this.props.theme) },
          _react2.default.createElement(
            _webform2.default,
            null,
            this.props.settings.title && _react2.default.createElement(
              _formTitle2.default,
              null,
              this.props.settings.title
            ),
            this.state.status !== Webform.formStates.SENT && errorsEl,
            this.state.status !== Webform.formStates.SENT && _react2.default.createElement(
              'form',
              {
                method: 'POST',
                onSubmit: this.onSubmit,
                name: this.props.form.form_id,
                id: this.props.form.form_id,
                noValidate: this.props.noValidation
              },
              requiredHint,
              formElements,
              renderCaptcha()
            ),
            this.props.showThankYouMessage && this.state.status === Webform.formStates.SENT && _react2.default.createElement(_ThankYouMessage2.default, { message: this.props.form.settings.confirmation_message })
          )
        )
      );
    }
  }]);
  return Webform;
}(_react.Component), _class2.formStates = {
  DEFAULT: 'DEFAULT',
  SENT: 'SENT',
  ERROR: 'ERROR',
  PENDING: 'PENDING',
  CONVERTED: 'CONVERTED'
}, _class2.analyticsEventsCategories = {
  SUCCESSFUL: 'Successful submission',
  ERROR: 'Error during submission'
}, _class2.analyticsEventsActions = {
  FORM_SUBMISSION: 'Form Submission'
}, _class2.propTypes = {
  url: _propTypes2.default.string.isRequired,
  settings: _propTypes2.default.shape({
    title: _propTypes2.default.string,
    tracking: _propTypes2.default.oneOfType([_propTypes2.default.shape({
      gtm_id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
    }), _propTypes2.default.bool]),
    langcode: _propTypes2.default.string
  }).isRequired,
  form: _propTypes2.default.shape({
    form_id: _propTypes2.default.string.isRequired,
    settings: _propTypes2.default.shape({
      nm_gtm_id: _propTypes2.default.string,
      nm_required_hint: _propTypes2.default.string,
      confirmation_message: _propTypes2.default.string
    }),
    elements: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      '#type': _propTypes2.default.string.isRequired
    })).isRequired,
    token: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
    langcode: _propTypes2.default.string
  }).isRequired,
  onSubmit: _propTypes2.default.func,
  onSubmitSuccess: _propTypes2.default.func,
  onSubmitFail: _propTypes2.default.func,
  defaultValues: _propTypes2.default.objectOf(_propTypes2.default.string),
  hiddenData: _propTypes2.default.objectOf(_propTypes2.default.string),
  noValidation: _propTypes2.default.bool,
  showThankYouMessage: _propTypes2.default.bool,
  theme: _propTypes2.default.shape(),
  loadingTimeout: _propTypes2.default.number,
  loadingComponent: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
}, _class2.defaultProps = {
  onSubmit: function onSubmit() {},
  onSubmitSuccess: function onSubmitSuccess() {},
  onSubmitFail: function onSubmitFail() {},
  nm_gtm_id: false,
  settings: {
    tracking: false
  },
  defaultValues: {},
  hiddenData: {},
  noValidation: true,
  showThankYouMessage: true,
  theme: {},
  loadingTimeout: 500,
  loadingComponent: undefined
}, _temp)) || _class;

exports.default = Webform;